/**
 * First-touch acquisition capture.
 *
 * The backend can't see where a user came from — the UTM params and
 * document.referrer live on the *landing page* URL, not on the API requests
 * the React app makes. So we read them here on first load and POST them once
 * per browser. First touch wins: we persist the original values so a reload
 * (before a successful send) never loses the real source.
 */
import { sendAttribution } from '../services/api';
import { getPlatform } from './native';

const SENT_KEY = 'wl_attribution_sent';
const FIRST_TOUCH_KEY = 'wl_first_touch';

export async function captureAttributionOnce() {
    try {
        if (typeof window === 'undefined' || !window.localStorage) return;
        if (localStorage.getItem(SENT_KEY)) return;

        let firstTouch = null;
        try {
            firstTouch = JSON.parse(localStorage.getItem(FIRST_TOUCH_KEY) || 'null');
        } catch (e) { /* ignore corrupt value */ }

        if (!firstTouch) {
            const params = new URLSearchParams(window.location.search || '');
            const get = (k) => params.get(k) || null;
            firstTouch = {
                utm_source: get('utm_source'),
                utm_medium: get('utm_medium'),
                utm_campaign: get('utm_campaign'),
                utm_content: get('utm_content'),
                utm_term: get('utm_term'),
                gclid: get('gclid'),
                fbclid: get('fbclid'),
                referrer: document.referrer || null,
                landing_path: (window.location.pathname || '') + (window.location.search || ''),
            };
            try {
                localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(firstTouch));
            } catch (e) { /* storage full / private mode — proceed anyway */ }
        }

        const res = await sendAttribution({ ...firstTouch, platform: getPlatform() });
        if (res && res.ok) {
            try { localStorage.setItem(SENT_KEY, '1'); } catch (e) { /* ignore */ }
        }
    } catch (e) {
        // Best-effort only; attribution must never affect the app.
    }
}
